import React, { useState, useEffect, useMemo } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import ReactSlider from 'react-slider';
import classnames from 'classnames';

import { Button, ButtonGroup } from 'reactstrap';
import FundSelector from "./components/FundSelector";
import ResultsTable from "./components/ResultsTable";

import DisclosuresHTML from "./components/DisclosuresHTML"

import axios from 'axios';

import Modal from 'react-bootstrap/Modal'

import Header from "./components/Header"
import Footer from "./components/Footer"
import PostFooter from "./components/PostFooter"
import { tealiumTrack } from './utils/tealium';


export default function App(props) {

	const API_URL = '/api/getPyramidResponse';
	const arrFunds = {
		"BINC": { label: 'BINC: iShares Flexible Income Bond Active ETF', value: 'BINC'},
		"HIMU": { label: 'HIMU: iShares High Yield Muni Active ETF', value: 'HIMU'},
		"HYDB": { label: 'HYDB: iShares High Yield Systematic Bond ETF', value: 'HYDB'},
		"SGOV": { label: 'SGOV: iShares 0-3 Month Treasury Bond ETF', value: 'SGOV'},
		"STIP": { label: 'STIP: iShares 0-5 Year TIPS Bond ETF', value: 'STIP'},
		"NEAR": { label: 'NEAR: iShares Short Duration Bond Active ETF', value: 'NEAR'},
		"MEAR": { label: 'MEAR: iShares Short Maturity Municipal Bond Active ETF', value: 'MEAR'},		
		"BMSIX": { label: 'BMSIX: BlackRock  Income Fund', value: 'BMSIX'},
		"BSIIX": { label: 'BSIIX: BlackRock Strategic Income Opportunities Fund', value: 'BSIIX'},
		"IUSB": { label: 'IUSB: iShares Core Total USD Bond Market ETF', value: 'IUSB'},
		"MAYHX": { label: 'MAYHX: BlackRock High Yield Municipal Fund', value: 'MAYHX'},
		"MAMTX": { label: 'MAMTX: BlackRock Strategic Municipal OpportunitiesFund', value: 'MAMTX'},
		"MUB": { label: 'MUB: iShares National Municipal Bond ETF', value: 'MUB'},
		"ISTB": { label: 'ISTB: iShares Core 1-5 Year USD Bond ETF', value: 'ISTB'},
		"MAHQX": { label: 'MAHQX: BlackRock Total Return Fund', value: 'MAHQX'},
		"SUB": { label: 'SUB: iShares Short-Term National Municipal Bond ETF', value: 'SUB'},
		"MANLX": { label: 'MANLX: BlackRock National Municipal Fund', value: 'MANLX'},
		"AGG": { label: 'AGG: iShares Core U.S. Aggregate Bond ETF', value: 'AGG'},
		"BHYIX": { label: 'BHYIX: BlackRock High Yield Bond Fund', value: 'BHYIX'},
		"BFMSX": { label: 'BFMSX: BlackRock Low Duration Bond Fund', value: 'BFMSX'},
		"BFMCX": { label: 'BFMCX: BlackRock Core Bond Fund', value: 'BFMCX'},
		"USHY": { label: 'USHY: iShares Broad USD High Yield Corporate Bond ETF', value: 'USHY'},
		"SHYM": { label: 'SHYM: iShares High Yield Muni Income Active ETF', value: 'SHYM' },
		"MALMX": { label: 'MALMX: BlackRock Short Duration Muni Fund', value: 'MALMX' },
		"N/A": { label: 'N/A', value: 'N/A'}
	}

	const uploadedFileLink='favicon.ico';

	const [sliderValue, setSliderValue] = useState(0);

	const [allocation, setAllocation] = useState('C');
	const [taxMuniciple, setTaxMuniciple] = useState('tax');

	const [incomeValue, setIncomeValue] = useState(arrFunds['BMSIX']);
	const [incomeAllocation, setIncomeAllocation] = useState(30);
	const [incomeOptions, setIncomeOptions] = useState([]);
	const [incomeWidth, setIncomeWdith] = useState(0);

	const [capitalValue, setCapitalValue] = useState(arrFunds['BSIIX']);
	const [capitalAllocation, setCapitalAllocation] = useState(30);
	const [capitalOptions, setCapitalOptions] = useState([]);
	const [capitalWidth, setCapitalWidth] = useState(0);

	const [equityValue, setEquityValue] = useState(arrFunds['IUSB']);
	const [equityAllocation, setEquityAllocation] = useState(40);
	const [equityOptions, setEquityOptions] = useState([]);
	const [equityWidth, setEquityWidth] = useState(0);

	const [resultsData, setResultsData] = useState({});

	const formatResponseDate = (dateString, longFormat = false) => {
		if (!dateString) return '';

		const [year, month, day] = dateString.split('-').map(Number);
		const date = new Date(year, month - 1, day);

		return new Intl.DateTimeFormat('en-US', {
			month: longFormat ? 'long' : 'numeric',
			day: 'numeric',
			year: 'numeric'
		}).format(date);
	};

	const modDateFormat = useMemo(
		() => formatResponseDate(resultsData?.portfolioResponse?.date),
		[resultsData?.portfolioResponse?.date]
	);

	const modDateFormatTwo = useMemo(
		() => formatResponseDate(resultsData?.portfolioResponse?.date, true),
		[resultsData?.portfolioResponse?.date]
	);

		// Internet Explorer 6-11
		const isIE = /*@cc_on!@*/false || !!document.documentMode;

		const stats = useMemo(() => {
			const segments = [
				incomeValue && incomeValue.value !== 'N/A' ? `${incomeValue.value}|${incomeAllocation || 0}` : null,
				capitalValue && capitalValue.value !== 'N/A' ? `${capitalValue.value}|${capitalAllocation || 0}` : null,
				equityValue && equityValue.value !== 'N/A' ? `${equityValue.value}|${equityAllocation || 0}` : null
			].filter(Boolean); // Remove null values
		
			return {
				uri360: segments.join(':')
			};
		}, [incomeValue, capitalValue, equityValue, incomeAllocation, capitalAllocation, equityAllocation]);
		
	
	useEffect(() => {
	
			tealiumTrack('bond-pyramid:tab-selected:get-started','view')
	
	},[])


	// Used to build the bars (pink yellow orange)
	const totalBarWidth = 90
	useEffect(() => {
		// get the max value

			console.log('e'+equityAllocation)
			console.log('i'+incomeAllocation)
			console.log('c'+capitalAllocation)


		let max = Math.max(incomeAllocation,capitalAllocation,equityAllocation)

		//The highest value will get 90% (totalBarWidth) of the div, the other values will get percentage
		if (incomeAllocation === 100) {
			setIncomeWdith(totalBarWidth)
		} else if (incomeAllocation === 0) {
			setIncomeWdith(25)
		} else if (incomeAllocation === 10 || incomeAllocation === 20) {
			setIncomeWdith(22)
		} else {
			setIncomeWdith(incomeAllocation)
		}

		if (capitalAllocation === 100) {
			setCapitalWidth(totalBarWidth)
		} else {
			setCapitalWidth(capitalAllocation)
		}

			console.log('eq')
			console.log(equityAllocation)
		if (equityAllocation === 100) {
			setEquityWidth(totalBarWidth)
		} else {
			setEquityWidth(equityAllocation)
		}
	},[incomeAllocation,capitalAllocation,equityAllocation])

	useEffect(() => {
		
		if (allocation === 'C') {
			setIncomeAllocation(30)
			setCapitalAllocation(30)
			setEquityAllocation(40)
		} else if (allocation === 'M') {
			setIncomeAllocation(20)
			setCapitalAllocation(30)
			setEquityAllocation(50)
		} else if (allocation === 'A') {
			setIncomeAllocation(10)
			setCapitalAllocation(30)
			setEquityAllocation(60)
		}

			if (taxMuniciple === 'tax') {
				
				setIncomeOptions(['BINC','BHYIX','BMSIX','HYDB','USHY']);
				setIncomeValue(arrFunds['BMSIX']);
				
				setCapitalOptions(['BSIIX','NEAR','BFMSX','SGOV','STIP']);
				setCapitalValue(arrFunds['BSIIX']);
				
				setEquityOptions(['MAHQX','BFMCX','AGG','IUSB']);
				setEquityValue(arrFunds['IUSB']);
				
			} else {		

				setIncomeOptions(['HIMU','SHYM']);
				setIncomeValue(arrFunds['HIMU']);
				
				setCapitalOptions(['MEAR','MALMX']);
				setCapitalValue(arrFunds['MEAR']);

				setEquityOptions(['MAMTX','MUB']);
				setEquityValue(arrFunds['MAMTX']);
				
			}

	},[allocation,taxMuniciple])

	useEffect(() => {
		fetchData()
	},[incomeValue,capitalValue,equityValue])

	const fncBuildPayload = () => {
		return {
			incomeValue: incomeValue.value,
			incomeAllocation: incomeAllocation,
			capitalValue: capitalValue.value,
			capitalAllocation: capitalAllocation,
			equityValue: equityValue.value,
			equityAllocation: equityAllocation
		}
	}

	const fetchData = () => {
		setResultsData({})
		return new Promise((resolve, reject) => {
				axios.post(
					API_URL,
					fncBuildPayload()
				).then((results) => {
					setResultsData(results.data)
					resolve()
				}).catch((err) => {
					reject()
				})
		})
	};


	let tealiumLink = (href,title,cls,cls2) => {

	

		return (
			
				<a href="#" onClick={(e) => fncOpenHref(href,title)}>
		
				<button className={cls2}>{title} <i className={cls} /></button>
			
				</a>

		)
	}

	let tealiumLinkFooter = (href,title) => {

	

		return (
			
				<a href="#" className="moreinfo" onClick={(e) => fncOpenHref(href,title)}>{title}</a>

		)
	}	


	let fncOpenHref = (href,title) => {
	
		tealiumTrack('bond-pyramid:link:'+title,'link')

	   if (isIE) {
			const newWindowIEH = window.open(href, '_blank', 'width=1200,height=800,scrollbars=1,location=no,menubar=no,toolbar=no,resizable=yes,status=yes').focus();
	   } else {
			const newWindowH = window.open(href, '_blank', 'noopener,noreferrer');
	   }



	}

	const [methodologyModal, setMethodologyModal] = useState(false);

	// if the modal is open, let tealium know about it. 
useEffect(() => {
	if (methodologyModal) tealiumTrack('core-etfs:link:view methodology')
},[methodologyModal])

	return (
		<div className="app app-l" >
			<Header />
			<div className="container"> 
				<section className="row header-section">
					<div className="col-12">
						<h3>Get started with the BlackRock Bond Pyramid</h3>
						<p>
							Use the BlackRock Bond Pyramid to build a bond allocation that is tailored to your overall portfolio.
						</p>
					</div>
				</section>

				<section className="row body-section">
					<div className="col-6 offset">
						<div className="stack-landing">
							
							<div className="pink">
								<section >
									<div className="stack-landing-col rounded-box-dark" style={{width:incomeWidth + '%'}}>
										
											<div>{incomeAllocation}%</div>
											<div className="ticker">{incomeValue.value}</div>
									
										
									</div>
								</section>
							</div>
							
							<div className="yellow">
								<section>
									<div className="stack-landing-col rounded-box-dark" style={{width:capitalWidth + '%'}}> 
									
									<div>{capitalAllocation}%</div>
									<div className="ticker">{capitalValue.value}</div>
										
									</div>
								</section>
																		
							</div>
							<div className="orange">
								<section>
									<div className="stack-landing-col rounded-box-dark" style={{width:equityWidth + '%'}}>
									
									<div>{equityAllocation}%</div>
									<div className="ticker">{equityValue.value}</div>
										
									</div>
								</section>
																												
							</div>
						</div>
						<div className="legend">
							<div className="legend-item">
								<div className="legend-glyph pink"></div>
								<div>Income</div>
							</div>
							
							<div className="legend-item">
								<div className="legend-glyph yellow"></div>
								<div>Stability</div>
							</div>
							<div className="legend-item">
								<div className="legend-glyph orange"></div>
								<div>Equity diversification</div>
							</div>
						</div>
						<ResultsTable 
							resultsData={resultsData} 
						/>
					</div>
					<div className="col-6">
						<div className="steps">Step 1: Select your overall asset allocation</div>
						
				

						<div className="slider-container">
						
						<ReactSlider
                                                value={sliderValue}
                                                className="toggle-slider"
                                                min={0}
                                                max={2}
                                                marks
                                                withTracks={true}                                         
                                                markClassName="slider-mark"
                                                step={1}
                                                thumbClassName="slider-thumb"
                                                trackClassName="slider-track"
												
                                                onChange={(newValue) => {
                                                    setSliderValue(newValue);
													if (newValue == 1) {
														setAllocation('M');
														tealiumTrack('bond-pyramid:button-selected:moderate','link')
													} else if (newValue == 2) {
														setAllocation('A');
														tealiumTrack('bond-pyramid:button-selected:aggressive','link')
													} else {
														setAllocation('C');
														tealiumTrack('bond-pyramid:button-selected:conservative','link')
													}
                                                }}
                                            />
                                            <div className="gutter">
                                                <span className={classnames({ active: sliderValue === 0 })} onClick={() => { setSliderValue(0); setAllocation('C'); tealiumTrack('bond-pyramid:button-selected:conservative','link')  } }>Conservative</span>
												<span className={classnames({ active: sliderValue === 1 })} onClick={() => { setSliderValue(1); setAllocation('M'); tealiumTrack('bond-pyramid:button-selected:moderate','link')  } }><span className="offset-16">Moderate</span></span>
                                                <span className={classnames({ active: sliderValue === 2 })} onClick={() => { setSliderValue(2); setAllocation('A'); tealiumTrack('bond-pyramid:button-selected:aggressive','link') } }>Aggressive</span>
                                            </div>

						</div>

					

						<div className="steps">Step 2: Choose Taxable or Municipal</div>
						<ButtonGroup size="lg" className="horizontal-button btnGroup">
							<Button  id="btn1" className="custom-btn" active={taxMuniciple === 'tax'} value="tax" onClick={() => {setTaxMuniciple('tax');tealiumTrack('bond-pyramid:button-selected:tax','link') }} >Taxable</Button>
							<Button  className="custom-btn" active={taxMuniciple === 'municipal'} value="municipal" onClick={() => {setTaxMuniciple('municipal');tealiumTrack('bond-pyramid:button-selected:municipal','link') }}  >Municipal</Button>
						</ButtonGroup>

						<div className="steps">Step 3: Adjust funds as needed</div>
						<div>
							<FundSelector text="Income" value={incomeValue} 
								options={incomeOptions.map((cur) => arrFunds[cur])}
								onChange={value => {
									setIncomeValue(value);
									tealiumTrack('bond-pyramid:dropdown:income','link')
								}}
							/>
						</div>
						
						<div>
							<FundSelector text="Stability" value={capitalValue} 
								options={capitalOptions.map((cur) => arrFunds[cur])}
								onChange={value => {
									setCapitalValue(value);
									tealiumTrack('bond-pyramid:dropdown:capital','link')
								}}
							/>
						</div>
						<div>
								<FundSelector text="Equity diversification" value={equityValue} 
									options={equityOptions.map((cur) => arrFunds[cur])}
									onChange={value => {
										setEquityValue(value);
										tealiumTrack('bond-pyramid:dropdown:value','link')
									}}
								/>
						</div>

						<div className="links">

					
							
							{tealiumLink('https://' +process.env.REACT_APP_BR_URL+ '/us/financial-professionals/tools/360-evaluator-tool/portfolio-editor/edit?holdings='+encodeURIComponent(stats.uri360),'Run analysis','icon fa fa-angle-right','')}

				


						</div>
					</div>
					<div className="vm">
					<p><a className="moreinfo" onClick={() => setMethodologyModal(true)}>View methodology.</a> For important additional information, <a className="moreinfo" href="#bp-disclosures">click here</a>.</p>              
								
								<p>*Source: Morningstar Direct as of {modDateFormat}. Yield shown is 12-month yield. Average effective duration, standard deviation and correlation are calculated for each fund and averaged based on allocation assigned within Bond Pyramid.</p>
								
								
								<p className="performanceText"><i>Performance data represents past performance and does not guarantee future results. Investment return and principal value will 
									fluctuate with market conditions and may be lower or higher when you sell your shares. Current performance may differ from the performance 
									shown and may be found by visiting <a className="moreinfo" href="https://www.ishares.com" target="_blank">www.ishares.com</a> and <a className="moreinfo" href="https://www.blackrock.com" target="_blank">www.blackrock.com</a>.</i></p>




									<p>For most recent month-end performance and standardized performance, visit the respective fund's product page:</p>

									<p>
	<a href="https://www.blackrock.com/us/financial-professionals/products/331752/" target="_blank">iShares Flexible Income Active ETF</a>,&nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227557/" target="_blank">BlackRock High Yield Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227615/" target="_blank">BlackRock Income Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/288478/" target="_blank">iShares High Yield Systematic Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/291299/" target="_blank">iShares Broad USD High Yield Corporate Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227660/" target="_blank">BlackRock Strategic Income Opportunities Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/239854/" target="_blank">iShares Short Duration Bond Active ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227598/" target="_blank">BlackRock Low Duration Bond Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/314116/" target="_blank">iShares 0-3 Month Treasury Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/239450/" target="_blank">iShares 0-5 Year TIPS Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227777/" target="_blank">BlackRock Total Return Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227526/" target="_blank">BlackRock Core Bond Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/239458/" target="_blank">iShares Core U.S. Aggregate Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/264615/" target="_blank">iShares Core Total USD Bond Market ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/341516/" target="_blank">iShares High Yield Muni Active ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/317978/" target="_blank">iShares High Yield Muni Income Active ETF</a>,&nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/272112/" target="_blank">iShares Short Maturity Municipal Bond Active ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227663/" target="_blank">BlackRock Short Duration Muni Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227581/" target="_blank">BlackRock Strategic Municipal Opportunities Fund</a>, and &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/239766/" target="_blank">iShares National Muni Bond ETF</a>.
</p>



									</div>


				</section>
			</div>
			

			
			<Modal
						size="lg"
						show={methodologyModal}
						onHide={() => setMethodologyModal(false)}
						dialogClassName="modal-90w"
						aria-labelledby="example-modal-sizes-title-lg">	
			
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-lg">
								Methodology
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
					
                        
 


<>
	<p>
		The “Bond Pyramid” experience (the “tool”) is designed to help investors learn how BlackRock actively managed bond mutual
		funds and iShares bond ETFs can work together in a portfolio to help clients achieve their financial goals. BlackRock mapped
		relevant Morningstar categories to the Bond Pyramid goals (income, stability and equity diversification) based on the
		category’s historical characteristics and role in a portfolio. BlackRock actively managed mutual funds and iShares ETFs were
		selected that have more than $1B in assets under management and are the lowest cost option (based on net expense ratio) by
		vehicle, Morningstar category and Bond Pyramid goal. For flexible municipal bond funds such as the BlackRock Strategic Income
		Opportunities Fund, BlackRock assigns the funds to the Bond Pyramid’s stability goal due the funds’ historical
		characteristics, which tend to more closely align to this goal.
	</p>

	<p>
		The tool and products shown are not customized for any particular portfolio or investment circumstance. BlackRock, iShares
		and other third-party firms may consider other products that also relate to the outcomes shown. The outcomes shown are for
		illustrative purposes only and do not represent all possible investor outcomes. The funds shown are intended to illustrate
		possible investment ideas to consider. This information should not be relied upon as research, investment advice, or a
		recommendation regarding any products, strategies, or any security in particular. Any fund selection is not tailored to the
		investment objectives or needs of any particular investor. Investors should consult with their financial professionals prior
		to making an investment decision.
	</p>

	<p>
		As of {modDateFormatTwo}. BlackRock funds and iShares ETFs launched after {modDateFormatTwo} are not displayed in the tool.
		BlackRock and iShares product selections are reviewed quarterly to ensure the mutual funds and ETFs included in the tool meet
		the defined criteria. All other data is updated quarterly.
	</p>
</>




                        </Modal.Body>
					</Modal>


			<Footer />

			<PostFooter />

		

		</div>
	);
}
